import React, { Dispatch, SetStateAction } from 'react';
import { Category } from '@services';

export const CategoriesTreeContext = React.createContext<{
    categories: Category[] | [],
    setCategories: Dispatch<SetStateAction<Category[] | []>>
}>({
  categories: [],
  setCategories: () => []
});
